"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfferableIdenitytOperator = void 0;
var ethers_1 = require("ethers");
var did_resolver_interface_1 = require("@ew-did-registry/did-resolver-interface");
var did_ethr_resolver_1 = require("@ew-did-registry/did-ethr-resolver");
var OfferableIdentity_json_1 = require("../build/contracts/OfferableIdentity.json");
var ERC1056_json_1 = require("../constants/ERC1056.json");
var BigNumber = ethers_1.utils.BigNumber, Interface = ethers_1.utils.Interface, formatBytes32String = ethers_1.utils.formatBytes32String;
var PublicKey = did_resolver_interface_1.DIDAttribute.PublicKey, ServicePoint = did_resolver_interface_1.DIDAttribute.ServicePoint;
var OfferableIdenitytOperator = /** @class */ (function (_super) {
    __extends(OfferableIdenitytOperator, _super);
    /**
     *
     * @param owner - Owner of the idenity
     * @param settings - Settings to connect to Ethr registry
     * @param identityAddr {string} - address of controlled offerable identity
     */
    function OfferableIdenitytOperator(owner, settings, identityAddr) {
        var _this = _super.call(this, owner, settings) || this;
        _this.identity = new ethers_1.Contract(identityAddr, OfferableIdentity_json_1.abi, owner);
        return _this;
    }
    OfferableIdenitytOperator.prototype.revokeDelegate = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                throw new Error('Not supported');
            });
        });
    };
    /* eslint-disable @typescript-eslint/no-unused-vars */
    OfferableIdenitytOperator.prototype.changeOwner = function (identityDID, newOwnerDid) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                throw new Error('Not supported');
            });
        });
    };
    /* eslint-enable @typescript-eslint/no-unused-vars */
    /**
     * @todo
     */
    OfferableIdenitytOperator.prototype.deactivate = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                throw new Error('Not supported yet');
            });
        });
    };
    OfferableIdenitytOperator.prototype.getAddress = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.identity.address];
            });
        });
    };
    OfferableIdenitytOperator.prototype.offer = function (offerTo) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.identity.offer(new Interface(OfferableIdentity_json_1.abi).functions.offer.encode([offerTo]), this.settings.address, 0)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, true];
                }
            });
        });
    };
    OfferableIdenitytOperator.prototype._sendTransaction = function (method, did, didAttribute, updateData, validity) {
        return __awaiter(this, void 0, void 0, function () {
            var identity, attributeName, bytesOfAttribute, bytesOfValue, validityValue, params, methodName, data, tx, receipt, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        identity = did_ethr_resolver_1.addressOf(did);
                        attributeName = this._composeAttributeName(didAttribute, updateData);
                        bytesOfAttribute = formatBytes32String(attributeName);
                        bytesOfValue = did_ethr_resolver_1.hexify(didAttribute === PublicKey || didAttribute === ServicePoint
                            ? updateData.value
                            : updateData.delegate);
                        validityValue = validity !== undefined ? validity.toString() : '';
                        params = [identity, bytesOfAttribute, bytesOfValue, validityValue];
                        if (didAttribute === did_resolver_interface_1.DIDAttribute.PublicKey || didAttribute === did_resolver_interface_1.DIDAttribute.ServicePoint) {
                            methodName = 'setAttribute';
                        }
                        else {
                            methodName = 'addDelegate';
                        }
                        data = new Interface(ERC1056_json_1.abi).functions[methodName].encode(params);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, this.identity.sendTransaction(this._contract.address, data, 0)];
                    case 2:
                        tx = _a.sent();
                        return [4 /*yield*/, tx.wait()];
                    case 3:
                        receipt = _a.sent();
                        return [2 /*return*/, new BigNumber(receipt.blockNumber)];
                    case 4:
                        e_1 = _a.sent();
                        throw new Error(e_1);
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    return OfferableIdenitytOperator;
}(did_ethr_resolver_1.Operator));
exports.OfferableIdenitytOperator = OfferableIdenitytOperator;
//# sourceMappingURL=offerableIdentityOperator.js.map